export default {
  isEdit: false,
  issueId: 0,
  title: '',
  description: '',
  date: {
    startDate: null,
    endDate: null,
    key: 'selection'
  }
}
